// extracted by mini-css-extract-plugin
module.exports = {"shopping-page":"ShoppingPage_shopping-page__39nG8","vertical-line":"ShoppingPage_vertical-line__23QML"};